<template>
    <v-dialog v-model="imageUploadModal" scrollable persistent full-width max-width='933'>
        <v-card>
            <v-card-title>
                <v-flex>
                    <span class="titulo-detalhes pl-4  mt-2 mb-2 headline">Subir Imagem</span>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex class="text-xs-right">
                <v-btn icon @click.native="close">
                    <v-icon>close</v-icon>
                </v-btn>
                </v-flex>
            </v-card-title>
            <v-card-text class="pa-0">
                <v-layout row wrap class="pl-5 pr-5 mt-3">
                    <v-flex xs12 md12 pb-3 class="logo">
                        <div v-if="imgUploadImage" class="item-image-box">
                            <img :src="imgUploadImage" alt="">
                            <div class="photo-actions">
                                <div class="alter">
                                    <v-icon>insert_photo</v-icon> Alterar
                                    <input class="invisible-all" type="file" name="" value="" v-on:change="shelfImage">
                                </div>
                                <div class="remove" @click="removeImage">
                                    <v-icon>close</v-icon> Remover
                                </div>
                            </div>
                        </div>
                        <template v-else>
                            <v-layout row wrap v-if="shelfedImage !== ''">
                                <v-flex xs6 md3 mr-3 v-if="cropperOn">
                                <div>
                                    <img :src="shelfedImage"  alt="" id="imgToCrop" >
                                </div>
                                <div class="crop-action" @click="crop">
                                    <v-icon>done</v-icon> Recortar
                                </div>
                                </v-flex>
                                <v-flex xs6 md3>
                                <div class="cropped-box">
                                    <div class="crop-preview">
                                    <img :src="shelfedImage" :style="cropPreviewStyle" alt="" >
                                    </div>
                                    <div class="photo-actions" v-if="!cropperOn">
                                    <div class="alter">
                                        <v-icon>insert_photo</v-icon> Alterar
                                        <input class="invisible-all" type="file" name="" value="" v-on:change="shelfImage">
                                    </div>
                                    <div class="remove" @click="unshelfImage" >
                                        <v-icon>close</v-icon> Remover
                                    </div>
                                    </div>
                                </div>
                                </v-flex>
                            </v-layout>
                            <template v-else>
                                <input class="invisible-all" type="file" name="" value="" v-on:change="shelfImage">
                                <div class="item-image-box">
                                <div class="pa-2 noselect foto">
                                    <v-icon>insert_photo</v-icon>
                                    imagem do item
                                </div>
                                </div>
                            </template>
                        </template>
                    </v-flex>
                </v-layout>
            </v-card-text>
            
        </v-card>
    </v-dialog>
</template>

<script>
import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.css'

export default {
  name: 'image-upload',
  components: {
    Cropper
  },
  data () {
    return {
      cropper: false,
      cropperOn: false,
      cropPreviewStyle: {
        width: '0',
        height: '0',
        transform: ''
      },
      shelfedImage: '',
      image: ''
    }
  },
  created () {
  },
  methods: {
    removeImage () {
      this.shelfedImage = ''
    },
    updateImage (value) {
      this.shelfedImage = value
    },
    shelfImage (elem) {
      let image = {
        elem: elem.target.files[0],
        size: elem.target.files[0].size,
        extension: elem.target.value.substring(elem.target.value.lastIndexOf('.') + 1).toLowerCase()
      }
      if (image.size > 3000000) {
        this.$store.commit('toastr', {
          color: 'error',
          texto: 'Insira uma image de até 3mb'
        })
        return
      }
      if (image.extension === 'gif' || image.extension === 'png' || image.extension === 'bmp' ||
      image.extension === 'jpeg' || image.extension === 'jpg') {
        let reader = new FileReader()
        reader.onload = (e) => {
          this.shelfedImage = e.target.result
        }
        reader.readAsDataURL(image.elem)
        this.image = image.elem
      } else {
        this.$store.commit('toastr', {
          color: 'error',
          texto: 'Insira uma imagem com a extensão .png'
        })
      }
    },
    unshelfImage () {
      this.shelfedImage = ''
    },
    crop () {
      this.$store.commit('updateImgUploadCrop', this.cropper.getData())
      this.cropper.destroy()
      this.cropper = false
      this.cropperOn = false
      this.$store.dispatch('uploadItemImage', this.image)
      this.shelfedImage = ''
    },
    close () {
      if (this.cropper) {
        this.cropper.destroy()
      }
      this.shelfedImage = ''
      this.$store.commit('updateImgUploadImage', '')
      this.imageUploadModal = false
    }
  },
  computed: {
    imageUploadModal: {
      get () {
        return this.$store.getters.imgUploadVisible
      },
      set () {
        this.dataTags = ''
        this.$store.commit('toggleImgUploadModal', false)
      }
    },
    imgUploadImage: {
      get () {
        return this.$store.getters.imgUploadImage
      }
    },
    imgUploadIndex: {
      get () {
        return this.$store.getters.imgUploadIndex
      }
    }
  },
  watch: {
    shelfedImage () {
      if (this.shelfedImage) {
        this.cropperOn = true
        let vueObj = this
        this.$nextTick(() => {
          let cropper = new Cropper(document.getElementById('imgToCrop'), {
            viewMode: 3,
            aspectRatio: 1,
            movable: false,
            zoomable: false,
            handleWidth: 16,
            handleOffset: -10,
            crop (event) {
              let scale = 200 / event.detail.width
              vueObj.cropPreviewStyle.width = event.target.width * scale + 'px'
              vueObj.cropPreviewStyle.height = event.target.height * scale + 'px'
              vueObj.cropPreviewStyle.transform = 'translateX(-' + (event.detail.x * scale) + 'px) translateY(-' + (event.detail.y * scale) + 'px)'
            }
          })
          this.cropper = cropper
        })
      } else {
        if (this.cropper) {
          this.cropper.destroy()
          this.cropper = false
        }
      }
    }
  }
}
</script>
<style>
.invisible-all{
  z-index: 1;
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  width: 100%;
}
.outerDiv{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;

}
input[type=file]::-webkit-file-upload-button {
  display: none;
}
.photo-actions > div > i{
  color:#fff!important
}
.photo-actions > div{
  float: left;
  width: 50%;
  position: absolute;
  text-align: center;
  bottom: 0;
  cursor: pointer;
  height:30px;
}
.photo-actions .remove{
  right: 0;
}
.photo-actions{
  position: absolute;
  bottom: 0;
  top: 0;
  width: 100%;
  color:#fff!important;
  background-size: cover;
  background-image: url('https://www.ettravel.com/wp-content/uploads/2016/06/GRADIENT-OVERLAY.png');
}
.crop-preview{
  width: 200px;
  height: 200px;
  overflow: hidden;
  text-align: center;
}
.crop-preview img{
  max-width: none;
  max-height: none;
  min-width: 0;
  min-height: 0;
  display: block;
}
#imgToCrop{
  max-width: 200px;
  max-height: 200px;
}
.item-image-box img{
  width: 200px;
  height: 200px;
}
.crop-action{
  cursor: pointer;
  width: 200px;
  text-align: center;
}
.cropped-box, .item-image-box{
  width: 200px;
  height: 200px;
  position: relative;
}

</style>



// WEBPACK FOOTER //
// imageUpload.vue?06d30020